/**
 * ForceLogoutDialog
 *
 * Shown automatically when the API client receives a 401 or 403 response.
 * The `forceLogout` flag in authStore is set by `src/lib/api-client.ts`.
 */

import { useNavigate } from '@tanstack/react-router'

import { useAuthStore } from '@/shared/auth/stores/authStore'

export function ForceLogoutDialog() {
  const forceLogout = useAuthStore((s) => s.forceLogout)
  const logout = useAuthStore((s) => s.logout)
  const clearForceLogout = useAuthStore((s) => s.clearForceLogout)
  const navigate = useNavigate()

  if (!forceLogout) {return null}

  const handleConfirm = async () => {
    clearForceLogout()
    await logout()
    await navigate({ to: '/login' })
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-sm rounded-xl bg-white p-6 text-center shadow-xl sm:p-8">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
          <svg
            className="h-6 w-6 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
        </div>

        <h2 className="text-lg font-semibold text-gray-900">Session Expired</h2>
        <p className="mt-2 text-sm leading-relaxed text-gray-500">
          Your session has expired or you are not authorized. Please log in again to continue.
        </p>

        <button
          onClick={handleConfirm}
          className="mt-6 w-full rounded-full bg-[#2258B5] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#1a4a9a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2258B5] focus-visible:ring-offset-2"
        >
          Log Out
        </button>
      </div>
    </div>
  )
}
